const initMenu = (menu) => {
    const body = document.querySelector('.js-body');
    const menuToggles = document.querySelectorAll('.js-menu-button');
    const stopScrollingClass = 'stop-scrolling';
    const isActiveClass = 'menu-open';

    window.menuOpen = false;

    document.addEventListener('click', (event) => {
        // If menu is open and wrapper is clicked, close it
        if (window.menuOpen && event.target === menu) {
            window.menuOpen = false;
            body.classList.remove(stopScrollingClass, isActiveClass);
        }

        // If toggle is clicked, do the thing
        if ([...menuToggles].includes(event.target)) {
            event.preventDefault();
            window.menuOpen = !window.menuOpen;

            // Close search
            if (window.searchOpen) {
                body.classList.remove('search-open');
                window.searchOpen = false;
            }

            if (window.menuOpen) {
                body.classList.add(stopScrollingClass, isActiveClass);
            } else {
                body.classList.remove(stopScrollingClass, isActiveClass);
            }
        }
    });
};

export { initMenu as default };
